import { isChapterContentDeletionRequiresForceError, isChapterVersionConflictError } from '@/utils/chapterErrors'
import { getHttpErrorStatus } from '@/utils/httpErrorStatus'
import { isConnectivityError } from '@/utils/isConnectivityError'

/**
 * PATCH outcome is unknown: timeout, network, or gateway 5xx without a business error body.
 */
export function isAmbiguousSaveFailure(error: unknown): boolean {
  if (isChapterVersionConflictError(error) || isChapterContentDeletionRequiresForceError(error)) {
    return false
  }

  if (isConnectivityError(error)) {
    return true
  }

  const status = getHttpErrorStatus(error)
  if (status === 502 || status === 503 || status === 504) {
    return true
  }

  return false
}
